<div class="cm-tracking-map"
  [hidden]="showPlaceholder"
  #googleMap></div>

<div *ngIf="showPlaceholder"
  class="cm-map-placeholder-image h-100">
</div>